import { getConstructorPagesSettings, getConstructorPreviewPage, getConstructorSectionSettings } from '../slices';

export function getConstructorParentSectionInstanceId(childInstanceId: string) {
    const currentPage = getConstructorPreviewPage();
    const currentSettings = getConstructorSectionSettings(currentPage, childInstanceId);
    const pages = getConstructorPagesSettings();

    if (!pages || !currentSettings) {
        return null;
    }

    const parentPage = Object.values(pages).find((page) =>
        page.layout.some((section) => section.id === currentSettings.id && section.section_type === 'parent')
    );

    if (!parentPage) {
        return null;
    }

    const parentSection = pages[parentPage.id]?.layout.find(
        (section) => section.id === currentSettings.id && section.section_type === 'parent'
    );

    if (!parentSection) {
        return null;
    }

    return {
        parentPageId: parentPage.id,
        parentSectionInstanceId: parentSection.instance_id,
    };
}
